import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileText, LogOut, Settings } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const AdminNavbar = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/admin/dashboard" className="font-bold text-xl text-ctc-blue">
              Better Water Blog Admin
            </Link>
          </div>
          
          {/* Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link
              to="/admin/dashboard"
              className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
                isActive('/admin/dashboard') 
                  ? 'bg-ctc-blue/10 text-ctc-blue' 
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <LayoutDashboard size={18} />
              <span>Dashboard</span>
            </Link>
            
            <Link
              to="/admin/posts"
              className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
                isActive('/admin/posts') 
                  ? 'bg-ctc-blue/10 text-ctc-blue' 
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <FileText size={18} />
              <span>Posts</span>
            </Link>
            
            <div className="flex items-center space-x-2 px-3 py-2 rounded-lg text-gray-400 cursor-not-allowed">
              <Settings size={18} />
              <span>Settings</span>
            </div>
          </div>
          
          {/* Actions */}
          <div className="flex items-center space-x-4">
            <Link
              to="/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-ctc-blue transition-colors"
            >
              View Site
            </Link>
            
            <button
              onClick={() => {
                logout();
                navigate('/admin');
              }}
              className="flex items-center space-x-2 text-gray-700 hover:text-red-600 transition-colors"
            >
              <LogOut size={18} />
              <span className="hidden md:inline">Logout</span>
            </button>
          </div>
        </div>
        
        {/* Mobile Navigation */}
        <div className="md:hidden flex justify-between border-t border-gray-100 py-2">
          <Link
            to="/admin/dashboard"
            className={`flex flex-col items-center px-3 py-2 rounded-lg transition-colors ${
              isActive('/admin/dashboard') 
                ? 'bg-ctc-blue/10 text-ctc-blue' 
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <LayoutDashboard size={18} />
            <span className="text-xs mt-1">Dashboard</span>
          </Link>
          
          <Link
            to="/admin/posts"
            className={`flex flex-col items-center px-3 py-2 rounded-lg transition-colors ${
              isActive('/admin/posts') 
                ? 'bg-ctc-blue/10 text-ctc-blue' 
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <FileText size={18} />
            <span className="text-xs mt-1">Posts</span>
          </Link>
          
          <div className="flex flex-col items-center px-3 py-2 rounded-lg text-gray-400 cursor-not-allowed">
            <Settings size={18} />
            <span className="text-xs mt-1">Settings</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminNavbar;